import { useLocation } from 'react-router-dom';

function useIsModal() {
  const location = useLocation();

  return (location.state as { modal?: boolean } | undefined)?.modal === true;
}

export default useIsModal;
